import React, { forwardRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FiGrid, FiTrendingUp, FiDollarSign, FiSettings, FiLogOut } from "react-icons/fi";
import { FaIndianRupeeSign } from "react-icons/fa6";

const NAV_ITEMS = [
  { title: "Dashboard", path: (tenantId) => `/dashboard/${tenantId}`, icon: <FiGrid />, adminOnly: false },
  { title: "Analytics", path: (tenantId) => `/analytics/${tenantId}`, icon: <FiTrendingUp />, adminOnly: false },
  { title: "Billing", path: (tenantId) => `/billing-history/${tenantId}`, icon: <FaIndianRupeeSign />, adminOnly: true }, 
  { title: "Settings", path: (tenantId) => `/tenant-settings/${tenantId}`, icon: <FiSettings />, adminOnly: true }, 
];

const SidebarItem = ({ item, active, sidebarOpen, onClick }) => (
  <button
    onClick={onClick}
    aria-current={active ? "page" : undefined}
    className={`group flex items-center w-full transition-colors duration-150 border-l-2 ${
      sidebarOpen ? "px-4 py-2.5" : "p-2.5 justify-center"
    } ${
      active
        ? "border-l-[#B89D4F] bg-white/[0.06] text-white font-semibold"
        : "border-l-transparent text-[#D9CADD] hover:bg-white/[0.04] hover:text-white"
    }`}
  >
    <span className="text-base shrink-0" aria-hidden="true">
      {item.icon}
    </span>
    {sidebarOpen && <span className="ml-3 text-sm truncate">{item.title}</span>}
  </button>
);

const Sidebar = forwardRef(function Sidebar(
  { tenantId, companyName, sidebarOpen, onBeforeLogout, userRole = "member" },
  ref
) {
  const navigate = useNavigate();
  const location = useLocation();
  const isAdmin = userRole === "admin";

  const companyInitial = companyName ? companyName[0].toUpperCase() : "D";
  

  const handleLogout = () => {
    if (onBeforeLogout) onBeforeLogout();
    localStorage.clear();
    navigate("/");
  };

  // 🔑 Filter items: If not admin, exclude items marked as adminOnly
  const visibleItems = NAV_ITEMS.filter(item => !item.adminOnly || isAdmin);

  return (
    <aside
      ref={ref}
      className="fixed top-0 left-0 h-full bg-[#4A2E50] border-r border-black/10 transition-all duration-200 z-40"
      style={{ width: sidebarOpen ? 240 : 72 }}
      aria-label="Main navigation"
    >
      <div className="flex items-center px-4 h-16 border-b border-white/10">
        <div className="w-8 h-8 rounded-md bg-[#B89D4F] flex items-center justify-center shrink-0" aria-hidden="true">
          <span className="text-white text-sm font-bold">{companyInitial}</span>
        </div>
        {sidebarOpen && (
          <div className="ml-3 flex flex-col justify-center overflow-hidden">
            <span className="text-white font-semibold text-sm truncate">{companyName || "Workspace"}</span>
            <span className="text-[#B9A6BC] text-[10px] uppercase tracking-wider">Workspace</span>
          </div>
        )}
      </div>

      <nav className="mt-4 space-y-0.5" role="navigation">
        {visibleItems.map((item) => {
          const path = item.path(tenantId);
          const active = location.pathname.startsWith(path);
          
          return (
            <SidebarItem
              key={item.title}
              item={item}
              active={active}
              sidebarOpen={sidebarOpen}
              onClick={() => {
                navigate(path);
              }}
            />
          );
        })}
      </nav>

      {/* <div className="absolute bottom-4 left-0 right-0 px-3">
        <button
          onClick={handleLogout}
          className="w-full flex items-center justify-center gap-2 px-4 py-2.5 border border-white/15 hover:bg-white/[0.06] text-white text-sm font-medium rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-[#B89D4F]/50"
          aria-label="Logout"
        >
          <FiLogOut size={15} />
          {sidebarOpen && "Logout"}
        </button>
      </div> */}
    </aside>
  );
});

export default Sidebar;